import { useAccount } from './useAccount';

export const useUserIsConfirmed = () => {
  const accountQuery = useAccount();
  return {
    ...accountQuery,
    data: accountQuery.isSuccess ? accountQuery.data.user.confirmed : undefined,
  };
};
